<template>
  <div class="scroll-button" v-on:click="scroll">
    <div class="abs--center"></div>
  </div>
</template>

<style lang="scss">
.scroll-button{
  position: absolute;
  background-color: white;
  width: 6rem;
  height: 6rem;
  border-radius: 100%;
  cursor: pointer;
  transition: all .3s ease;

  @media #{$bp-sm-up}{
    top: calc( 100vh - 18rem );
    right: 12rem;
  }
  @media #{$bp-sm}{
    bottom: 3rem;
    right: 3rem;
  }
  
  div{
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 5px 5px 0 5px;
    border-color: black transparent transparent transparent;
    z-index: 10; 
    transition: all .3s ease;
  }

  &:hover{
    background-color: black;
    div{
      border-color: white transparent transparent transparent;
    }
  }
}
</style>

<script>
import animejs from 'animejs'

export default {
  data() {
    return {
      scrollPosition: 0
    };
  },
  methods: {
    scroll(){
      this.scrollPosition = window.scrollY || window.pageYOffset || document.body.scrollTop + (document.documentElement && document.documentElement.scrollTop || 0)
      animejs({
        targets: this,
        scrollPosition: window.innerHeight,
        easing: 'easeInOutCubic',
        update: ()=>{
          window.scrollTo(0,this.scrollPosition)
        }
      });
    }
  },
};
</script>
